export default __webpack_public_path__ + "static/media/ok.ae8ab4ac.mp3";